import request from '@/utils/request'

export function getDeliveryFeeConfigList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/deliveryFeeConfig.listDeliveryFeeConfigs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '获取手续费配置失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

export function addDeliveryFeeConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/deliveryFeeConfig.saveDeliveryFeeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '新增手续费配置失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateDeliveryFeeConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/deliveryFeeConfig.updateDeliveryFeeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '更新手续费配置失败'))
    }).catch(error => {
      reject(error)
    })
  })
}
